export enum TextEditorTools
{
    Translation = 'Translation',
    TextExpand = 'TextExpand',
    TextChange = 'TextChange',
    TextTone = 'TextTone',
    TextCorrection = 'TextCorrection',
    Summarization = 'Summarization',
    GrammarCheck = 'GrammarCheck',
    CustomPrompt = 'CustomPrompt',
    TextGeneration = 'TextGeneration'
};

export type TextEditorPayload = TranslationTool
    | TextExpandTool
    | TextChangeTool
    | TextToneTool
    | TextCorrectionTool
    | SummarizationTool
    | GrammarCheckTool
    | CustomPromptTool
    | TextGenerationTool;

export interface TranslationTool
{
    Tool: TextEditorTools.Translation;
    Translation: {
        Text: string;
        Language: string;
    };
}

export interface TextExpandTool
{
    Tool: TextEditorTools.TextExpand;
    TextExpand: {
        Text: string;
    };
}

export interface TextChangeTool
{
    Tool: TextEditorTools.TextChange;
    TextChange: {
        Text: string;
        Style: string;
    };
}

export interface TextToneTool
{
    Tool: TextEditorTools.TextTone;
    TextTone: {
        Text: string;
        Tone: string;
    };
}

export interface TextCorrectionTool
{
    Tool: TextEditorTools.TextCorrection;
    TextCorrection: {
        Text: string;
    };
}

export interface SummarizationTool
{
    Tool: TextEditorTools.Summarization;
    Summarization: {
        Text: string;
    };
}

export interface GrammarCheckTool
{
    Tool: TextEditorTools.GrammarCheck;
    GrammarCheck: {
        Text: string;
    };
}

export interface CustomPromptTool
{
    Tool: TextEditorTools.CustomPrompt;
    CustomPrompt: {
        Text: string;
        Prompt: string;
    };
}

export interface TextGenerationTool
{
    Tool: TextEditorTools.TextGeneration;
    TextGeneration: {
        Prompt: string;
    };
}

export interface TextEditorResponse
{
    message: string;
}
